<template>
    <div class="container">
        <div class="title-box">
            <div class="logo"><img src="../assets/images/logo-white.png"></div>
            <h3>APEX工具箱</h3>
        </div>
        <div class="big-box">
            <div>APEX</div>
            <div class="big-box1">ToolB<img src="../assets/images/toolboxIcon.png">x</div>
        </div>
        <div class="description-box">最好用的APEX打单工具,高效,快捷,<br>一站式解决APEX相关需求</div>
        <div class="login-box">
            <div class="login-box-bg">
            </div>
            <form class="login-form">
                <h2>LOGIN</h2>
                <div class="form-group">
                    <label for="username">用户名</label>
                    <el-input v-model="username" class="username" id="username"></el-input>
                </div>
                <div class="form-group">
                    <label for="password" class="password-name">密码</label>
                    <el-input v-model="password" show-password class="password" id="password"></el-input>
                </div>
                <button @click.prevent="login">登录</button>
            </form>
        </div>
        <div class="footer-message">An efficient and fast APEX toolbox for you!</div>
    </div>
</template>

<script>
    import api from "../request/api";

    export default {
        data() {
            return {
                username: "",
                password: "",
            };
        },
        methods: {
            login() {
                if (this.username === "" || this.password === "") {
                    this.$message.error("账号或密码不能为空!");
                } else {
                    api.post("/apextb/users/login", {
                        userAccount: this.username,
                        userPassword: this.password,
                    }).then(
                        (response) => {
                            if (response.data.code === "20000") {
                                // sessionStorage.setItem(
                                //     "token",
                                //     response.data.token
                                // );
                                // sessionStorage.setItem(
                                //     "username",
                                //     this.username
                                // );
                                // sessionStorage.setItem(
                                //     "role",
                                //     response.data.user.role
                                // );

                                // this.$message.success("登录成功!");
                                this.$router.push("/HomePage");
                            }
                        },
                        (error) => {
                            if (error.response.data.code === "10000") {
                                this.$message.error("登陆失败，账号或密码错误!");
                            }
                        }
                    );
                }
            },
        },
    };
</script>

<style scoped>
    .container {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .title-box {
        display: flex;
        align-items: center;
        position: absolute;
        top: 50px;
        left: 50px;
    }
    .logo {
        width: 25px;
        height: 30px;
        background-color: #000;
    }
    .logo img {
        height: 28px;
    }
    .title-box h3 {
        margin-left: 8px;
        font-size: 30px;
        letter-spacing: 0.5rem;
    }

    .big-box {
        position: absolute;
        left: 10%;
        top: 25%;
    }
    .big-box div {
        font-size: 90px;
        letter-spacing: 0.3rem;
    }
    .big-box1 {
        margin-left: 5rem;
    }
    .big-box1 img {
        width: 50px;
    }

    .description-box {
        position: absolute;
        left: 10%;
        top: 60%;
        font-size: 28px;
        text-align: right;
        letter-spacing: 0.3rem;
    }

    .login-box {
        position: absolute;
        right: 10%;
        top: 50%;
        transform: translateY(-50%);
        width: 420px;
        height: 520px;
    }
    .login-box-bg {
        position: absolute;
        right: 0px;
        width: 350px;
        height: 450px;
        background-color: #0f0f0f;
        border-radius: 15px;
    }
    .login-form {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        bottom: 0px;
        width: 250px;
        height: 350px;
        padding: 50px;
        background-color: #fff;
        border-radius: 15px;
    }
    .login-form h2 {
        margin-bottom: 48px;
        font-size: 60px;
        color: #b3b4b3;
        letter-spacing: 0.4rem;
    }
    .form-group {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        width: 100%;
        height: 40px;
    }
    .form-group label {
        font-weight: bold;
    }
    .form-group .password-name {
        letter-spacing: 1rem;
    }
    .form-group .username,
    .form-group .password {
        margin-left: auto;
        width: 180px;
    }
    .login-form button {
        width: 100%;
        height: 40px;
        background-color: #80fdff;
        border: none;
        border-radius: 5px;
    }

    .footer-message {
        position: absolute;
        bottom: 5%;
        margin-left: 50px;
        color: #b2b2b2;
        letter-spacing: 0.2em;
    }
</style>